module.exports = __webpack_public_path__ + "img/feedback_game_over.172f0544.gif";